
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Minibusonrentinmumbai() {



    const cardData =
    {
        keyword: ' Mini Bus on Rent in Mumbai',
        heading: 'Deva Cabs: Mini Bus on Rent in Mumbai   ',
        headingDescription: 'Deva Cabs offers spacious and well-equipped Mini Bus rentals in Mumbai, ideal for group travel, school trips, weddings, and corporate outings. Whether you are planning an outstation journey or a local event, our mini buses—ranging from 17 to 32 seaters—provide comfortable seating, ample luggage capacity, and smooth rides for large groups. With experienced drivers and clean, well-maintained vehicles, Deva Cabs ensures a safe, timely, and hassle-free travel experience every time.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

   "topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "Located at the waterfront in Colaba, the Gateway of India is Mumbai’s most iconic monument. Built in 1924 to honor the visit of King George V and Queen Mary, this massive basalt arch combines Indo-Saracenic architecture with colonial flair. Overlooking the Arabian Sea and facing the Taj Mahal Palace Hotel, it serves as a central tourist hub, with ferry rides to Elephanta Caves and local photographers capturing the city’s vibrant pulse. The Gateway is not just a historic landmark—it’s a symbol of Mumbai’s pride and resilience."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive is a 3.6-kilometer-long arc-shaped boulevard that stretches from Nariman Point to Girgaon Chowpatty. Also known as the 'Queen’s Necklace' for its glowing curve of street lights at night, it is a beloved seaside promenade for evening walks, breezy bike rides, and romantic sunsets. The backdrop of art deco buildings and the peaceful sound of waves create a rare urban serenity, making Marine Drive a timeless retreat in the heart of Mumbai."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are a complex of ancient Hindu and Buddhist rock-cut temples located on Elephanta Island, about 11 km from Mumbai. These 5th–8th century caves are renowned for their incredible sculptures of Lord Shiva, particularly the 20-foot-high Trimurti—the three-faced form of Shiva representing creation, preservation, and destruction. The island is accessible by ferry from the Gateway of India and offers a tranquil and culturally enriching day trip."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "The Shree Siddhivinayak Ganapati Mandir is one of Mumbai’s most spiritually significant landmarks, drawing millions of devotees each year. Dedicated to Lord Ganesha, the temple is famous for its beautiful black stone idol with a curved trunk and diamond-studded forehead. Rich in faith, energy, and devotion, the temple also showcases architectural beauty with its carved wooden doors and gold-plated sanctum. Tuesday is considered especially auspicious for darshan, attracting celebrities and commoners alike."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "location": "Mumbai, Maharashtra",
    "description": "A majestic example of Indo-Gothic architecture, Chhatrapati Shivaji Maharaj Terminus is both a UNESCO World Heritage Site and one of India’s busiest railway stations. Designed by British architect F.W. Stevens in 1887, it features elaborate stone carvings, pointed arches, domes, and turrets. The station is a vital part of Mumbai’s daily life while also standing as a living monument to the city’s colonial legacy and artistic grandeur."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is a bustling stretch of sandy coastline in suburban Mumbai, popular for sunsets, local street food, and Bollywood vibes. From joggers and kite-flyers to food stalls selling vada pav, bhel puri, and kulfi, the beach offers a true slice of Mumbai life. Celebrities often frequent nearby luxury homes, and the beach hosts cultural performances and film shoots throughout the year. It's the perfect blend of leisure and local flavor."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Built in the 15th century, the Haji Ali Dargah is a white-domed Indo-Islamic shrine located on an islet off the coast of Worli. The dargah houses the tomb of Sufi saint Haji Ali Shah Bukhari and is accessible via a narrow causeway during low tide. The spiritual calm, rhythmic sea waves, and panoramic sea views create a unique experience for visitors of all faiths. It is one of the most peaceful and scenic religious sites in Mumbai."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Spread across 104 square kilometers, Sanjay Gandhi National Park is Mumbai’s green oasis and a rare natural reserve within a bustling metropolis. The park is home to leopards, deer, monkeys, and countless bird species. A major highlight is the Kanheri Caves—ancient Buddhist cave carvings over 2,000 years old. With toy train rides, cycling trails, nature walks, and boating, the park is a perfect weekend escape for families, nature lovers, and adventure seekers."
  },
  {
    "title": "Chor Bazaar",
    "location": "Bhendi Bazaar, South Mumbai, Maharashtra",
    "description": "One of the oldest and most legendary flea markets in India, Chor Bazaar is a chaotic maze of shops offering antiques, Bollywood posters, vintage cameras, old clocks, and second-hand furniture. Despite the name (meaning 'Thieves Market'), it's a legal and vibrant place known for unexpected treasures and bargaining fun. Whether you're a collector or a curious explorer, this market is a true reflection of Mumbai’s vibrant street economy and layered history."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, Mumbai, Maharashtra",
    "description": "Girgaon Chowpatty is a central beach located at the northern end of Marine Drive. Known for its lively ambiance, it becomes a focal point during Ganesh Chaturthi for idol immersions. Food stalls offer classic Mumbai street snacks like pani puri, pav bhaji, and kulfi. Families, couples, and students often gather here to watch the sunset, fly kites, or simply relax by the sea. The beach offers both spiritual and recreational charm right in the heart of the city."
  }
],



"services": [
  {
    "name": "Mini Bus on Rent in Mumbai",
    "description": "Deva Cabs offers comfortable and well-maintained mini buses on rent in Mumbai for groups of all sizes. Whether you're planning a corporate outing, a family celebration, or a school trip, our fleet of mini buses provides ample seating, clean interiors, and reliable performance. With seating options ranging from 13 to 26 passengers, our mini buses are equipped with AC, push-back seats, and spacious luggage compartments. Enjoy smooth and safe rides backed by professional, courteous drivers who know Mumbai and surrounding routes well. Our mini bus rental service also includes route flexibility, transparent billing, and customer support throughout your journey."
  },
  {
    "name": "AC Mini Bus Hire in Mumbai",
    "description": "Beat the heat and travel in comfort with Deva Cabs' AC Mini Bus hire services in Mumbai. Perfect for group tours, airport transfers, weddings, or long-distance travel, our air-conditioned mini buses ensure a pleasant ride even in peak summer. Each vehicle is equipped with efficient cooling, comfortable seats, wide windows for sightseeing, and entertainment systems for passenger enjoyment. Whether you're moving within Mumbai or heading to nearby cities, our AC mini buses offer reliability, convenience, and affordability. We prioritize punctuality and cleanliness, and all vehicles undergo regular maintenance to ensure passenger safety and satisfaction."
  },
  {
    "name": "Mini Bus Booking in Mumbai",
    "description": "Booking a mini bus in Mumbai is hassle-free with Deva Cabs’ user-friendly platform and dedicated support team. Whether it’s for corporate logistics, religious travel, school outings, or weekend getaways, our mini buses cater to a wide range of group travel needs. Customers can choose from multiple seating capacities and optional add-ons like guides or extra luggage racks. We offer instant booking confirmation, competitive pricing, and both hourly and full-day rental options. Our transparent policies and excellent customer service ensure a worry-free booking experience for all your local and outstation journeys."
  },
  {
    "name": "Mini Bus on Rent from Mumbai to Shirdi",
    "description": "Plan a peaceful pilgrimage from Mumbai to Shirdi with Deva Cabs’ mini bus rental service. Our mini buses are ideal for groups visiting Sai Baba’s temple, offering a safe, comfortable, and budget-friendly travel experience. The journey is long, but our vehicles come equipped with AC, reclining seats, ample storage, and trained drivers who are familiar with the route. We also offer round-trip packages, customizable itineraries, and on-route support for a smooth religious tour. Enjoy devotional travel with family, friends, or society groups in comfort and peace of mind."
  },
  {
    "name": "Mini Bus on Rent from Mumbai to Lonavala",
    "description": "Escape to the scenic hills of Lonavala with Deva Cabs’ mini bus rentals from Mumbai. Ideal for day trips, school outings, or corporate getaways, our mini buses provide a cozy and efficient ride through winding ghat roads. With large windows for enjoying the natural beauty, AC cabins, and expert drivers, your group will enjoy every moment of the journey. Choose from flexible booking options, including same-day return or overnight stays. Our service includes on-time pickup, fuel-inclusive pricing, and vehicle cleanliness for a comfortable and memorable hill station trip."
  },
  {
    "name": "Hire Mini Bus in Mumbai",
    "description": "Looking to hire a mini bus in Mumbai for your next event or tour? Deva Cabs offers a wide selection of mini buses suitable for all group sizes and purposes. Whether it’s a corporate shuttle, outstation vacation, school tour, or family celebration, our vehicles offer comfort, safety, and value. All buses come with experienced drivers, valid permits, and safety features like seat belts and GPS tracking. You can opt for AC or non-AC models depending on your budget. With hourly, daily, and package-based rentals available, we make it easy to hire a mini bus that suits your exact travel plans."
  },
  {
    "name": "Mini Bus Hire for Local Sightseeing",
    "description": "Explore Mumbai’s landmarks with Deva Cabs’ mini bus hire for local sightseeing. Perfect for tourists, school groups, or wedding guests, our sightseeing packages include popular attractions like Gateway of India, Marine Drive, Elephanta Caves, Siddhivinayak Temple, and more. Our mini buses feature comfortable seating, clean interiors, AC, and experienced drivers who also serve as informal local guides. Flexible itineraries allow you to visit the places you want, on your own schedule. Enjoy a safe, spacious, and enjoyable sightseeing tour with Deva Cabs’ expert group transport solutions."
  },
  {
    "name": "Affordable Mini Bus Rental",
    "description": "Deva Cabs offers some of the most affordable mini bus rental options in Mumbai without compromising on quality or comfort. Whether you're looking for short-term rentals for a few hours or long-distance trips, we provide budget-friendly pricing packages that include fuel, driver allowance, and basic amenities. Ideal for students, religious groups, or mid-size families, our rental options are transparent, with no hidden fees. Choose from 13-seater, 17-seater, or 26-seater mini buses depending on your group size. Enjoy the convenience of group travel at competitive rates with Deva Cabs’ reliable mini bus services."
  },
  {
    "name": "Mumbai to Shirdi Mini Bus on Rent",
    "description": "Travel from Mumbai to Shirdi in comfort and safety with Deva Cabs’ mini bus rental service. Our 17 to 26-seater mini buses are ideal for temple groups, senior citizens, and spiritual tours, offering AC cabins, smooth suspensions, and experienced drivers who know the Shirdi route well. The journey includes highway travel and village roads, and our vehicles are built for all conditions. With early morning departures, optional stopovers at Nashik or Trimbakeshwar, and return trip planning, we make your pilgrimage stress-free and fully organized."
  },
  {
    "name": "Mumbai to Mahabaleshwar Mini Bus",
    "description": "Escape the city with a refreshing mini bus trip from Mumbai to Mahabaleshwar. Deva Cabs provides group rentals for this scenic hill station with mini buses that ensure a safe, air-conditioned, and enjoyable ride. Whether it’s a family vacation, school picnic, or corporate outing, our services include flexible pickup locations, overnight trip options, and professional drivers familiar with hilly terrain. Enjoy the winding roads and lush landscapes while we handle the transport logistics. Optional sightseeing stops include Panchgani, Mapro Garden, and Pratapgad Fort."
  },
  {
    "name": "Mumbai to Goa Mini Bus Rental",
    "description": "Planning a beach getaway? Deva Cabs offers mini bus rentals from Mumbai to Goa for group travel with friends, families, or office teams. Our mini buses feature plush seating, air-conditioning, music systems, and large luggage compartments—ideal for long-distance comfort. Choose from day/night departure, round-trip or one-way booking, and route customization options. With professional drivers who are familiar with the Mumbai–Goa route, your group can relax and enjoy the scenic journey through the Konkan region. Our packages include tolls, fuel, and driver allowance, ensuring a smooth travel experience from start to finish."
  },
  {
    "name": "Ashtavinayak Darshan Mini Bus on Rent",
    "description": "Embark on the spiritual Ashtavinayak Yatra from Mumbai with Deva Cabs’ mini bus rental services. Visit all eight revered Ganesh temples across Maharashtra in comfort and peace with your group. Our mini buses are well-suited for religious travel, offering spacious seating, AC comfort, and drivers familiar with the complete Ashtavinayak route. We also provide route planning assistance, overnight stay coordination, and on-road support for a safe and memorable pilgrimage. Custom packages are available for 2-day and 3-day tours with temple timings and parking considered in the itinerary."
  },
  {
    "name": "Mumbai to Nashik Mini Bus Rent",
    "description": "Travel from Mumbai to Nashik by mini bus with Deva Cabs for group visits to vineyards, temples, or events. Our 13- to 26-seater mini buses are perfect for college tours, religious visits to Trimbakeshwar, or Sula Vineyards day trips. Vehicles are equipped with air-conditioning, reclining seats, and skilled drivers. Enjoy scenic drives through the Ghats and reliable pickup/drop at your desired location. Affordable packages and customizable plans make this a perfect solution for all types of Nashik-bound group travel."
  },
  {
    "name": "Mumbai to Outstation Mini Bus Rent",
    "description": "Need to rent a mini bus for an outstation trip from Mumbai? Deva Cabs offers versatile rental options for group travel to popular destinations like Pune, Lonavala, Mahabaleshwar, Nashik, Goa, and more. Our mini buses are regularly serviced and come with GPS, first-aid kits, and experienced drivers. Choose from one-way or round-trip travel, overnight stays, and multi-city plans. Our team helps you plan routes, timings, and rest stops so your group can enjoy a worry-free travel experience."
  },
  {
    "name": "Mumbai to Bhimashankar Mini Bus on Rent",
    "description": "Book a mini bus from Mumbai to Bhimashankar with Deva Cabs for a smooth and comfortable spiritual journey. Visit the famous Jyotirlinga temple nestled in the Sahyadri hills with your group. Our mini buses are equipped for ghat roads, offering safety, AC, and reliable performance. Early morning pickups, optional breakfast halts, and flexible return schedules make it ideal for families, senior citizens, and temple groups. Let us handle your group travel needs while you focus on the divine experience."
  }
],
"tableData": [
  ["Mini Bus on Rent in Mumbai", "-AC Mini Bus Hire in Mumbai"],
  ["Mini Bus Booking in Mumbai", "-Mini Bus on Rent from Mumbai to Shirdi"],
  ["Mini Bus on Rent from Mumbai to Lonavala", "-Hire Mini Bus in Mumbai"],
  ["Mini Bus Hire for Local Sightseeing", "-Affordable Mini Bus Rental"],
  ["Mumbai to Shirdi Mini Bus on Rent", "-Mumbai to Mahabaleshwar Mini Bus"],
  ["Mumbai to Goa Mini Bus Rental", "-Ashtavinayak Darshan Mini Bus on Rent"],
  ["Mumbai to Nashik Mini Bus Rent", "-Mumbai to Outstation Mini Bus Rent"],
  ["Mumbai to Bhimashankar Mini Bus on Rent", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Spacious and Comfortable for Large Groups",
    "WhyChoosedescription": "Our Mini Bus rentals offer ample space to comfortably accommodate large groups, ideal for family outings, corporate events, school trips, or group tours in and around Mumbai. With ergonomic seating and plenty of legroom, every passenger enjoys a relaxed journey."
  },
  {
    "WhyChooseheading": "Ideal for Long-Distance and Outstation Trips",
    "WhyChoosedescription": "Well-maintained and equipped to handle long journeys smoothly, our Mini Buses are perfect for weekend getaways, pilgrimages, or intercity tours, ensuring a reliable and comfortable travel experience without breakdown worries."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "All drivers are experienced in handling large vehicles and familiar with Mumbai’s traffic patterns and highways. They prioritize safety, punctuality, and passenger comfort, ensuring your group arrives on time and stress-free."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Needs",
    "WhyChoosedescription": "We offer hourly, daily, and customized rental plans tailored to your itinerary. Whether for a few hours within the city or multiple days for extensive travel, our packages are flexible and affordable."
  },
  {
    "WhyChooseheading": "Modern Amenities for a Pleasant Ride",
    "WhyChoosedescription": "Our Mini Buses come equipped with air conditioning, ample storage for luggage, comfortable seating, and clean interiors, ensuring a pleasant and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Deva Cabs provides competitive rates with no hidden fees. Our transparent pricing model helps you budget confidently, with no surprises at the end of your journey."
  },
  {
    "WhyChooseheading": "24/7 Availability and Easy Booking",
    "WhyChoosedescription": "Whether it’s a last-minute group trip or a planned event, our Mini Buses are available round the clock. You can book easily via our website or customer support for seamless planning and execution."
  },
  {
    "WhyChooseheading": "Safe and Well-Maintained Vehicles",
    "WhyChoosedescription": "Safety is our top priority. All Mini Buses undergo regular maintenance and safety checks, are equipped with seat belts, GPS tracking, and clean interiors to guarantee a secure and comfortable journey."
  }
]









    }










const faqData = [
  {
    question: "Can I rent a mini bus in Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers mini bus rentals in Mumbai for group travel, corporate events, weddings, school trips, and more."
  },
  {
    question: "What is the seating capacity of the mini buses available for rent?",
    answer: "Our mini buses typically accommodate 18 to 30 passengers, ideal for medium to large groups."
  },
  {
    question: "Are mini buses suitable for long-distance or outstation travel?",
    answer: "Yes, our mini buses are designed for comfort and are perfect for long-distance journeys and outstation tours."
  },
  {
    question: "Can I book a mini bus for outstation trips from Mumbai?",
    answer: "Absolutely. We offer mini bus rentals for outstation travel to popular destinations like Lonavala, Shirdi, Pune, Goa, and more."
  },
  {
    question: "Is a driver included with the mini bus rental?",
    answer: "Yes, all mini bus rentals include a licensed, professional driver to ensure a safe and stress-free journey."
  },
  {
    question: "How do I book a mini bus in Mumbai?",
    answer: "You can book through our website, mobile app, or by calling our customer care team for quick and easy assistance."
  },
  {
    question: "What are the rental charges for mini buses in Mumbai?",
    answer: "The rental charges depend on the bus size, duration, and destination. Get in touch with us for a personalized quote."
  },
  {
    question: "Are your mini buses air-conditioned?",
    answer: "Yes, we offer both AC and non-AC mini buses to suit your comfort and budget preferences."
  },
  {
    question: "Are there extra charges for waiting time or additional kilometers?",
    answer: "Any extra charges for waiting time, additional kilometers, or night halts will be clearly communicated at the time of booking."
  },
  {
    question: "Why choose Deva Cabs for mini bus rental in Mumbai?",
    answer: "Deva Cabs offers clean, reliable mini buses, skilled drivers, transparent pricing, and excellent customer service."
  }
];

const testimonialData = [
  {
    id: 7,
    name: 'Mr. Vinay Patil',
    role: 'Tour Organizer',
    review: 'Booked a mini bus from Deva Cabs for a college picnic. The vehicle was spacious and clean, and the journey was very smooth. Highly satisfied!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 8,
    name: 'Mrs. Neha Sood',
    role: 'Wedding Planner',
    review: 'We hired a mini bus for wedding guest transportation. Everything was well-managed and punctual. Deva Cabs did a great job!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Mumbai",
  "image": "https://devacab.com/assets/images/mini-bus-on-rent-mumbai.jpg", // Replace with actual image URL
  "description": "Rent AC mini buses in Mumbai with Deva Cabs. Ideal for local sightseeing, outstation trips to Shirdi, Lonavala, Goa, Nashik, Mahabaleshwar, and more. Affordable, comfortable mini bus rentals with driver.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mini-bus-on-rent-in-mumbai" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mini Bus on Rent in Mumbai | AC Mini Bus Hire & Booking | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book AC mini buses on rent in Mumbai with Deva Cabs. Perfect for local sightseeing and outstation trips to Shirdi, Lonavala, Goa, Nashik, Mahabaleshwar, and more. Affordable and comfortable mini bus rentals." 
  />
  <meta 
    name="keywords" 
    content="Mini Bus on Rent in Mumbai, AC Mini Bus Hire in Mumbai, Mini Bus Booking in Mumbai, Mini Bus on Rent from Mumbai to Shirdi, Mini Bus on Rent from Mumbai to Lonavala, Hire Mini Bus in Mumbai, Mini Bus Hire for Local Sightseeing, Affordable Mini Bus Rental, Mumbai to Shirdi Mini Bus on Rent, Mumbai to Mahabaleshwar Mini Bus, Mumbai to Goa Mini Bus Rental, Ashtavinayak Darshan Mini Bus on Rent, Mumbai to Nashik Mini Bus Rent, Mumbai to Outstation Mini Bus Rent, Mumbai to Bhimashankar Mini Bus on Rent" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Minibusonrentinmumbai;